/* CCS Product Bundle — cart-aware product-info block. Standalone script asset. */
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.ccsBundleReady === 'true') return;
    const track = root.querySelector('[data-track]');
    const status = root.querySelector('[data-progress-text]');
    if (!track) {
      if(status) status.textContent = 'Choose a sticker collection to start your bundle.';
      return;
    }
    root.dataset.ccsBundleReady = 'true';
    const raw = root.querySelector('[data-eligible-ids]');
    let eligible = [];
    try { eligible = JSON.parse(raw ? raw.textContent : '[]').map(String); } catch (_) {}
    const ids = new Set(eligible);
    const milestones = [Number(root.dataset.tierOne || 3), Number(root.dataset.tierTwo || 5), Number(root.dataset.tierThree || 10)];
    const labels = [root.dataset.tierOneLabel || '£9.75', root.dataset.tierTwoLabel || '£13.00', root.dataset.tierThreeLabel || '£20.00'];
    const count = root.querySelector('[data-counter]');
    const bar = root.querySelector('[data-bar]');
    const fill = root.querySelector('[data-fill]');
    const feedback = root.querySelector('[data-feedback]');
    const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/').replace(/\/$/, '');
    const path = end => base + end;
    let pending = false;
    function setProgress(qty) {
      const max = milestones[2];
      const shown = Math.min(qty, max);
      if (count) count.textContent = qty + ' / ' + max;
      // The 5-sticker marker is deliberately centred visually between the
      // 3-sticker and 10-sticker markers. Map cart quantity to those same
      // positions instead of using a simple qty / 10 percentage.
      const [first, second, third] = milestones;
      const firstPosition = 100 * first / third;
      const middlePosition = (firstPosition + 100) / 2;
      let percent = 0;
      if (shown <= first) {
        percent = first > 0 ? shown / first * firstPosition : 0;
      } else if (shown <= second) {
        percent = firstPosition + (shown - first) / (second - first) * (middlePosition - firstPosition);
      } else {
        percent = middlePosition + (shown - second) / (third - second) * (100 - middlePosition);
      }
      if (fill) fill.style.width = Math.max(0, Math.min(100, percent)) + '%';
      if (bar) bar.setAttribute('aria-valuenow', String(shown));
      ['first','second','third'].forEach((name,i) => {
        const marker = root.querySelector('[data-' + name + '-marker]');
        if (marker) marker.classList.toggle('is-reached', qty >= milestones[i]);
      });
      if (!status) return;
      if (qty < milestones[0]) status.textContent = 'Add ' + (milestones[0] - qty) + ' more eligible sticker' + (milestones[0] - qty === 1 ? '' : 's') + ' to unlock ' + milestones[0] + ' for ' + labels[0];
      else if (qty < milestones[1]) status.textContent = 'First offer reached! Add ' + (milestones[1] - qty) + ' more to unlock ' + milestones[1] + ' for ' + labels[1];
      else if (qty < milestones[2]) status.textContent = 'Second offer reached! Add ' + (milestones[2] - qty) + ' more to unlock ' + milestones[2] + ' for ' + labels[2];
      else status.textContent = 'Your ' + milestones[2] + '-sticker milestone is reached!';
    }
    async function refresh() {
      if (!ids.size) { if(status) status.textContent='No eligible products found in this collection.'; return; }
      try {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 8000);
        let response;
        try { response = await fetch(path('/cart.js'), { credentials:'same-origin', cache:'no-store', signal:controller.signal }); }
        finally { clearTimeout(timeout); }
        if(!response.ok) throw new Error('Cart request failed: ' + response.status);
        const cart = await response.json();
        const qty = Array.isArray(cart.items) ? cart.items.reduce((total,item) => total + (ids.has(String(item.product_id)) ? Number(item.quantity || 0) : 0), 0) : 0;
        setProgress(qty);
      } catch (err) {
        if(status) status.textContent = 'Choose stickers to build your bundle — cart progress temporarily unavailable.';
        if(count) count.textContent = '—';
      }
    }
    track.addEventListener('click', async event => {
      const button = event.target.closest('[data-add]');
      if(!button || !track.contains(button) || pending) return;
      // Prevent delegated theme/app click handlers from treating this as a cart-open trigger.
      event.preventDefault();
      event.stopPropagation();
      pending=true; button.disabled=true;
      const old = button.textContent;
      button.textContent='ADDING…';
      if(feedback) feedback.textContent='';
      try {
        // Use a direct XMLHttpRequest for this widget's Add action. Some themes and
        // cart-drawer apps intercept window.fetch('/cart/add.js') and auto-open the
        // drawer; XHR avoids fetch-specific interception without affecting checkout.
        // An app that also monitors XHR or cart mutations may still open its drawer.
        await new Promise((resolve, reject) => {
          const xhr = new XMLHttpRequest();
          xhr.open('POST', path('/cart/add.js'), true);
          xhr.withCredentials = true;
          xhr.setRequestHeader('Content-Type', 'application/json');
          xhr.setRequestHeader('Accept', 'application/json');
          xhr.timeout = 12000;
          xhr.onload = () => {
            if (xhr.status >= 200 && xhr.status < 300) return resolve();
            let message = 'Could not add sticker';
            try {
              const json = JSON.parse(xhr.responseText);
              message = json.description || json.message || message;
            } catch (_) {}
            reject(new Error(message));
          };
          xhr.onerror = () => reject(new Error('Network error adding sticker'));
          xhr.ontimeout = () => reject(new Error('Adding sticker timed out'));
          xhr.send(JSON.stringify({items:[{id:Number(button.dataset.variantId),quantity:1}]}));
        });
        if(feedback) feedback.textContent='Sticker added to your cart.';
        button.textContent='ADDED ✓';
        await refresh();
        // Do not broadcast a cart-update event: some themes open the drawer on it.
        // This widget refreshes its own progress directly above.
      } catch (err) {
        if(feedback) feedback.textContent=err.message || 'Unable to add sticker';
        button.textContent=old;
      } finally {
        pending=false;
        button.disabled=false;
        setTimeout(()=>{if(button.isConnected)button.textContent=old;},1100);
      }
    });
    const prev=root.querySelector('[data-prev]'), next=root.querySelector('[data-next]');
    if(prev) prev.addEventListener('click',()=>track.scrollBy({left:-track.clientWidth*.8,behavior:'smooth'}));
    if(next) next.addEventListener('click',()=>track.scrollBy({left:track.clientWidth*.8,behavior:'smooth'}));
    document.addEventListener('visibilitychange',()=>{if(!document.hidden && root.isConnected) refresh();});
    window.addEventListener('pageshow',()=>{if(root.isConnected)refresh();});
    document.addEventListener('ccs:bundle-cart-updated',()=>{if(root.isConnected)refresh();});

    // Shopify's normal product form, quick-add and third-party cart actions do
    // not emit our bundle-specific event. Observe the user action without
    // cancelling it, and read the authoritative cart after it has settled.
    let syncTimer;
    function scheduleCartSync(delay) {
      if (!root.isConnected) return;
      clearTimeout(syncTimer);
      syncTimer = setTimeout(() => { if (root.isConnected && !document.hidden) refresh(); }, delay);
    }
    document.addEventListener('submit', event => {
      const form = event.target;
      if (form && form.matches && (form.matches('form[action*="/cart/add"]') || form.closest('product-form'))) {
        scheduleCartSync(700);
        setTimeout(() => { if(root.isConnected) refresh(); }, 1700);
      }
    }, true);
    // Some Dawn themes submit on click via JS and prevent the native submit.
    document.addEventListener('click', event => {
      const target = event.target.closest && event.target.closest('product-form button[type="submit"], form[action*="/cart/add"] button[type="submit"], .quick-add__submit');
      if (target && !root.contains(target)) scheduleCartSync(1200);
    }, true);
    // Shopify themes and apps may dispatch these after their own cart updates.
    ['cart:updated', 'cart:refresh', 'cart:change', 'cart:changed', 'cart:updated:ajax', 'theme:cart:change'].forEach(name => {
      document.addEventListener(name, () => scheduleCartSync(250));
      window.addEventListener(name, () => scheduleCartSync(250));
    });
    // Fallback for app-driven cart changes without standard events. Only check
    // while the page is visible; don't open the cart drawer or mutate the cart.
    const poll = setInterval(() => {
      if (!root.isConnected) { clearInterval(poll); return; }
      if (!document.hidden && !pending) refresh();
    }, 5000);
    refresh();
  }
  function initAll(container) {
    if (container && container.matches && container.matches('[data-ccs-bundle]')) init(container);
    if (container && container.querySelectorAll) container.querySelectorAll('[data-ccs-bundle]').forEach(init);
  }
  initAll(document);
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>initAll(document),{once:true});
  document.addEventListener('shopify:section:load', event=>initAll(event.target));
  // Shopify theme editor may re-render a Custom Liquid block without re-running scripts.
  if(window.MutationObserver){
    const observer = new MutationObserver(records => {
      for (const rec of records) for(const node of rec.addedNodes) if(node.nodeType===1) initAll(node);
    });
    observer.observe(document.documentElement,{childList:true,subtree:true});
  }
})();
